import { EnvironmentId, ProjectId, ThreadId } from "@afar-research/contracts";

import { useRightPanelStore } from "../../rightPanelStore";
import type { RightPanelSurface } from "../../rightPanelStore";
import type { WorkspaceSurfaceScope } from "../../workspaceSurfaceHost";
import { ThreadPullRequestDetail } from "./ThreadPullRequestDetail";

/**
 * Renders one pull request opened beside a thread. The Environment comes from the thread's own
 * scope rather than from the stored descriptor: two Environments can hold the same project, and
 * a panel beside a thread can only read on the Environment that thread lives on.
 */
export function ThreadPullRequestWorkspaceSurface({
  descriptor,
  scope,
}: {
  readonly descriptor: RightPanelSurface;
  readonly scope: WorkspaceSurfaceScope;
}) {
  // The renderer is registered per kind, so the narrowing happens here rather than in its type.
  if (descriptor.kind !== "pull-request" || scope.type !== "thread") return null;
  const threadRef = {
    environmentId: EnvironmentId.make(scope.workspace.environmentId),
    threadId: ThreadId.make(scope.threadId),
  } as const;
  return (
    <ThreadPullRequestDetail
      environmentId={threadRef.environmentId}
      projectId={ProjectId.make(descriptor.projectId)}
      host={descriptor.host}
      repository={descriptor.repository}
      number={descriptor.number}
      url={descriptor.url}
      onBack={() => {
        // Back is a return to the collection, not a close: the pull request stays open as its
        // own tab so returning to it does not have to find it again.
        useRightPanelStore.getState().open(threadRef, "pull-requests");
      }}
    />
  );
}
